import { wrapArray } from 'gleam-shared/helpers/nodash'
import { writeDomIdle } from 'gleam-shared/browser/fastDom'

export function withHightlight(callback) {
  return import(
    'gleam-shared/highlight/index.js'
    /* webpackChunkName: 'gleam-shared.highlight-js' */
  ).then(({ default: hljs }) => {
    return new Promise((resolve, reject) => {
      writeDomIdle(() => {
        try {
          Promise.resolve(callback(hljs)).then(resolve, reject)
        } catch (err) {
          reject(err)
        }
      })
    })
  })
}

export function lazyHighlight(els) {
  return withHightlight((hljs) => {
    for (const el of wrapArray(els)) {
      hljs.highlightElement(el)
    }
  })
}

export function lazyHighlightDocument(qs = 'pre code') {
  return withHightlight((hljs) => {
    for (const el of wrapArray(document.querySelectorAll(qs))) {
      hljs.highlightElement(el)
    }
  })
}
